import { get } from './';

// Hotels settings > Categories (Palace, Bed & breakfast, Hotel chain...).
export const getCategories = ({ locale } = {}) =>
  get(`/api/v1/categories?locale=${encodeURIComponent(locale ?? 'en')}`);
